
import { Action } from "../actions/toggleActionForEditorActions";
import { ActionType } from "../actionTypes";

export interface EditorFlyersActionsForPopups {
    isShowCreateNewFlyerPopup: boolean;
    isShowRightPanel: boolean;
    isZoomIn: boolean;
}

export class EditorFlyersActionsForPopupsInitialState implements EditorFlyersActionsForPopups {
    isShowCreateNewFlyerPopup = false;
    isShowRightPanel = true;
    isZoomIn = false;
}

const initialState = new EditorFlyersActionsForPopupsInitialState();

const reducer = (state: EditorFlyersActionsForPopups = initialState, action: Action) => {
    switch (action.type) {
        case ActionType.EDITOR_TOGGLE_FLYER_DETAILS_POPUP:
            return { ...state, isShowCreateNewFlyerPopup: action.payload };
        case ActionType.EDITOR_TOGGLE_FLYER_RIGHT_PANEL:
            return { ...state, isShowRightPanel: !state.isShowRightPanel };
        case ActionType.EDITOR_TOGGLE_ZOOM_IN_MODE_FOR_FRAMES_PROMOS_SCREENS:
            return { ...state, isZoomIn: !state.isZoomIn };
        default:
            return state;
    }
};

export default reducer;
